'use client';

import { useMemo } from 'react';
import { useCurrentLocale } from '@locales/client';
import useSWR from 'swr';
import { fetchGamesByIds } from './fetch-games-by-ids';
import { normalizeGameCatalogItems } from './types';
import { getGamesByIdsKey, normalizeGameIds } from './games-by-ids-logic';
import type { GameIdInput, GamesByIdsKey } from './games-by-ids-logic';

export { normalizeGameIds } from './games-by-ids-logic';

export const useGamesByIds = (ids?: readonly GameIdInput[] | null) => {
  const locale = useCurrentLocale();
  const stableIdsKey = normalizeGameIds(ids).join(',');
  const key = getGamesByIdsKey(locale, stableIdsKey);
  const { data, isLoading, error } = useSWR<
    unknown,
    unknown,
    GamesByIdsKey | null
  >(key, fetchGamesByIds);

  const games = useMemo(() => normalizeGameCatalogItems(data), [data]);

  return {
    games,
    isLoading: key ? isLoading : false,
    error,
  };
};
